import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LanguageService, SupportedLanguage, AVAILABLE_LANGUAGES, LanguageOption } from 'app/services/language.service';
import { UserService } from 'app/services/user.service';
import { ApiService } from 'app/shared/apis/api.service';
import { take } from 'rxjs/operators';
import { AutoTranslatePipe } from 'app/shared/pipes/translate.pipe';
import { AutoTranslateService } from 'app/services/auto-translate.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-language-selector',
    standalone: true,
    imports: [CommonModule, MatButtonModule, MatMenuModule, MatIconModule, MatProgressSpinnerModule, AutoTranslatePipe],
    templateUrl: './language-selector.component.html',
})
export class LanguageSelectorComponent implements OnInit, OnDestroy {
    selectedLanguage: SupportedLanguage = 'pt-br';
    languages: LanguageOption[] = AVAILABLE_LANGUAGES;
    showEmoji: { [key: string]: boolean } = {};
    isTranslating = false;
    private translationSubscription?: Subscription;

    constructor(
        private languageService: LanguageService,
        private autoTranslateService: AutoTranslateService,
        private userService: UserService,
    ) {}

    ngOnInit(): void {
        this.selectedLanguage = this.languageService.getCurrentLanguage();
        // Observar estado de tradução
        this.translationSubscription = this.autoTranslateService.getIsTranslating$().subscribe((isTranslating) => {
            this.isTranslating = isTranslating;
        });
    }

    ngOnDestroy(): void {
        if (this.translationSubscription) {
            this.translationSubscription.unsubscribe();
        }
    }

    get selectedLanguageOption(): LanguageOption | undefined {
        return this.languages.find((lang) => lang.code === this.selectedLanguage);
    }

    selectLanguage(language: SupportedLanguage): void {
        if (this.selectedLanguage !== language) {
            this.selectedLanguage = language;
            this.languageService.setLanguage(language);
        }
        const current = ApiService.user.value;
        if (current?.user_id) {
            this.userService
                .update({ user_id: current.user_id, preferred_ui_language: language } as any)
                .pipe(take(1))
                .subscribe({
                    next: (updated) => {
                        if (updated) {
                            ApiService.userNext({ ...current, ...updated, preferred_ui_language: language });
                        }
                    },
                    error: () => {
                        /* preferência local já foi gravada */
                    },
                });
        }
    }

    onFlagError(event: Event): void {
        const img = event.target as HTMLImageElement;
        const langCode = img.getAttribute('data-lang') || '';
        this.showEmoji[langCode] = true;
        img.style.display = 'none';
    }
}
